module.exports = __webpack_public_path__ + "img/close.d8986307.svg";